import { render, staticRenderFns } from "./TimeCompensationReport.vue?vue&type=template&id=23dec3da&"
import script from "./TimeCompensationReport.vue?vue&type=script&lang=js&"
export * from "./TimeCompensationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports